"use client";

import { c as _c } from "react/compiler-runtime";
import NFTImageBalance from "@/components/nft-image/NFTImageBalance";
import NFTMediaContainer from "@/components/nft-image/NFTMediaContainer";
import styles from "@/components/nft-image/NFTImage.module.scss";
import type { BaseRendererProps } from "@/components/nft-image/types/renderer-props";
import { getResolvedAnimationSrc } from "@/components/nft-image/utils/animation-source";
import { withArweaveFallback } from "@/components/nft-image/utils/gateway-fallback";
const globalScope = globalThis as typeof globalThis & {
  window?: Window | undefined;
};
export default function NFTVideoRenderer(props) {
  const $ = _c(45);
  let T0;
  let t0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== props.bgStyle || $[1] !== props.height || $[2] !== props.heightStyle || $[3] !== props.id || $[4] !== props.imageStyle || $[5] !== props.nft || $[6] !== props.showBalance || $[7] !== props.showOriginal) {
    const animationSrc = getResolvedAnimationSrc(props.nft);
    const animationClassName = styles.nftAnimation ?? "";
    const compressedAnimationSrc = "metadata" in props.nft ? props.nft.compressed_animation : undefined;
    let t13;
    bb0: {
      if (compressedAnimationSrc === undefined || compressedAnimationSrc === "") {
        t13 = undefined;
        break bb0;
      }
      try {
        const baseUrl = globalScope.window.location.href;
        let t14;
        if ($[22] !== compressedAnimationSrc) {
          t14 = new URL(compressedAnimationSrc, baseUrl);
          $[22] = compressedAnimationSrc;
          $[23] = t14;
        } else {
          t14 = $[23];
        }
        t13 = t14.href;
      } catch {
        t13 = undefined;
      }
    }
    const normalizedCompressedAnimationSrc = t13;
    T0 = NFTMediaContainer;
    t10 = props.bgStyle === "";
    t11 = `${animationClassName} ${props.heightStyle} ${props.bgStyle}`;
    if ($[24] !== props.height || $[25] !== props.nft || $[26] !== props.showBalance) {
      t12 = props.showBalance && <NFTImageBalance contract={props.nft.contract} tokenId={props.nft.id} height={props.height} />;
      $[24] = props.height;
      $[25] = props.nft;
      $[26] = props.showBalance;
      $[27] = t12;
    } else {
      t12 = $[27];
    }
    t0 = props.id ?? `video-${props.nft.id}`;
    t1 = true;
    t2 = true;
    t3 = true;
    t4 = true;
    t5 = true;
    t6 = "auto";
    t7 = !props.showOriginal && "metadata" in props.nft && props.nft.compressed_animation ? props.nft.compressed_animation : animationSrc;
    t8 = props.imageStyle;
    t9 = withArweaveFallback(t14 => {
      const {
        currentTarget
      } = t14;
      if ("metadata" in props.nft && currentTarget.src === normalizedCompressedAnimationSrc && animationSrc) {
        currentTarget.src = animationSrc;
      }
    });
    $[0] = props.bgStyle;
    $[1] = props.height;
    $[2] = props.heightStyle;
    $[3] = props.id;
    $[4] = props.imageStyle;
    $[5] = props.nft;
    $[6] = props.showBalance;
    $[7] = props.showOriginal;
    $[8] = T0;
    $[9] = t0;
    $[10] = t1;
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    T0 = $[8];
    t0 = $[9];
    t1 = $[10];
    t10 = $[11];
    t11 = $[12];
    t12 = $[13];
    t2 = $[14];
    t3 = $[15];
    t4 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  let t13;
  if ($[28] !== t0 || $[29] !== t1 || $[30] !== t2 || $[31] !== t3 || $[32] !== t4 || $[33] !== t5 || $[34] !== t6 || $[35] !== t7 || $[36] !== t8 || $[37] !== t9) {
    t13 = <video id={t0} autoPlay={t1} muted={t2} controls={t3} loop={t4} playsInline={t5} preload={t6} src={t7} className={t8} onError={t9} />;
    $[28] = t0;
    $[29] = t1;
    $[30] = t2;
    $[31] = t3;
    $[32] = t4;
    $[33] = t5;
    $[34] = t6;
    $[35] = t7;
    $[36] = t8;
    $[37] = t9;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== T0 || $[40] !== t10 || $[41] !== t11 || $[42] !== t12 || $[43] !== t13) {
    t14 = <T0 forceIronBackground={t10} className={t11}>{t12}{t13}</T0>;
    $[39] = T0;
    $[40] = t10;
    $[41] = t11;
    $[42] = t12;
    $[43] = t13;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  return t14;
}